export default "__VITE_ASSET__DsWu8cNT__"